import React from 'react';
import { Globe } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      data-testid="language-switcher-btn"
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-gray-300 hover:border-sky-500 hover:bg-sky-50 transition-all text-sm font-medium"
      aria-label="Switch language"
    >
      <span className={language === 'de' ? 'text-gray-400' : 'text-gray-700'}>EN</span>
      <span className="text-gray-300">/</span>
      <span className={language === 'de' ? 'text-gray-700' : 'text-gray-400'}>DE</span>
      <Globe className="w-4 h-4 ml-1 text-sky-600" />
    </button>
  );
};

export default LanguageSwitcher;
